// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__vo456","home_title":"preset_apps_home_title__K-mkO","foot":"preset_apps_foot__7MVKr"};